import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"

const FarmPondStoreProps = {
  loading: types.maybeNull(types.boolean),
  navigating: types.maybeNull(types.boolean),
}

/**
 * Model description here for TypeScript hints.
 */
export const FarmPondStoreModel = types
  .model("FarmPondStore")
  .props(FarmPondStoreProps)
  .extend(withRootStore)
  .extend(withEnvironment)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof FarmPondStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    setLoading: (loading) => {
      self.loading = loading
    },
    init() {
      this.set('loading', false)
      this.set('navigating', false)
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type FarmPondStoreType = Instance<typeof FarmPondStoreModel>
export interface FarmPondStore extends FarmPondStoreType {}
type FarmPondStoreSnapshotType = SnapshotOut<typeof FarmPondStoreModel>
export interface FarmPondStoreSnapshot extends FarmPondStoreSnapshotType {}
export const createFarmPondStoreDefaultModel = () => types.optional(FarmPondStoreModel, {})
